import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from '@/components/ui/button';

const StickyCta = ({ isVisible, onActionClick }) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-0 left-0 right-0 p-4 bg-card/80 backdrop-blur-md border-t border-border z-40 md:hidden shadow-2xl"
        >
          <Button
            onClick={onActionClick}
            className="w-full bg-primary text-primary-foreground hover:bg-primary/90 py-3 text-base pulse-glow-brand"
            size="lg"
          >
            Get Started Free
          </Button>
          <p className="text-center text-xs text-muted-foreground mt-2">No credit card required.</p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyCta;